import { useCallback, useEffect, useState } from 'react';

import { useConfig } from '@occc/config';
import { Location_Metrics_Mobile_Pay_Filter } from '@occc/graphql';

import {
  clearTransactionSetSelection,
  loadTransactionSetSelection,
  saveTransactionSetSelection,
} from './transaction-set-selection.storage';

import { DEFAULT_TRANSACTION_SET } from '../components/transaction-set-selector';

type UseTransactionSetSelectionResult = {
  transactionSet: Location_Metrics_Mobile_Pay_Filter;
  setTransactionSet: (value: Location_Metrics_Mobile_Pay_Filter) => void;
};

export const useTransactionSetSelection = (): UseTransactionSetSelectionResult => {
  const isMobilePayMetricsEnabled = useConfig('retailerConnectMobilePayMetrics.enabled');
  const configuredDefault = useConfig('retailerConnectMobilePayMetrics.defaultFilter');

  const [transactionSet, setStoredTransactionSet] = useState<Location_Metrics_Mobile_Pay_Filter>(
    () => loadTransactionSetSelection() ?? configuredDefault ?? DEFAULT_TRANSACTION_SET,
  );

  // A stale selection must not survive the flag being turned off, otherwise it
  // would resurface the moment the flag comes back on.
  useEffect(() => {
    if (!isMobilePayMetricsEnabled) {
      clearTransactionSetSelection();
      setStoredTransactionSet(configuredDefault ?? DEFAULT_TRANSACTION_SET);
    }
  }, [isMobilePayMetricsEnabled, configuredDefault]);

  const setTransactionSet = useCallback((value: Location_Metrics_Mobile_Pay_Filter) => {
    saveTransactionSetSelection(value);
    setStoredTransactionSet(value);
  }, []);

  return {
    transactionSet: isMobilePayMetricsEnabled ? transactionSet : DEFAULT_TRANSACTION_SET,
    setTransactionSet,
  };
};
